import React from 'react';
import { FaEnvelope } from 'react-icons/fa';

export function getAuthenticatedEmail(sessionUser) {
  return typeof sessionUser?.email === 'string' ? sessionUser.email.trim() : '';
}

export default function AuthenticatedEmailField({ email = '', loading = false, inputStyle }) {
  if (loading) {
    return (
      <div className="account-field account-field-loading" role="status" aria-live="polite">
        <span><FaEnvelope /> E-mail autenticado</span>
        <span>Carregando identidade autenticada…</span>
      </div>
    );
  }

  const visibleEmail = typeof email === 'string' ? email.trim() : '';

  return (
    <div className="account-field">
      <span id="authenticated-email-label"><FaEnvelope /> E-mail autenticado</span>
      <output
        style={{ ...inputStyle, display: 'block' }}
        aria-labelledby="authenticated-email-label"
        aria-readonly="true"
        role="textbox"
        data-authenticated-email="true"
      >
        {visibleEmail || 'E-mail não disponível nesta sessão'}
      </output>
      {!visibleEmail && <small>E-mail não informado pela identidade autenticada.</small>}
    </div>
  );
}
